<div class="card mb-3">
  <div class="card-body">
    <div class="input-group">
      <div class="custom-file">
        <label class="form-label h5 mb-2" for="inputGroupFile">Upload JS file</label>
        <input type="file" name="jsFileInput" class="form-control mb-3" id="inputGroupFile" required
          (change)="handleJsSelect($event)"
          accept=".js">
      </div>
    </div>
    
    <table class="table table-striped">
      <thead>
        <tr>
          <th scope="col">File</th>
        </tr>
      </thead>
    
      <tbody *ngIf="!!jsFile; else emptyState">
        <tr>
          <td>{{ jsFile.name }}</td>
        </tr>
      </tbody>
    
      <ng-template #emptyState>
        <tbody>
          <tr class="empty-state-row">
            <td colspan="7" class="empty-state">Please upload a replacement JS file.</td>
          </tr>
        </tbody>
      </ng-template>
    </table>
  </div>

  <div class="card-footer">
    <div class="card-footer-button-error-wrapper">
      <button type="button" class="btn btn-primary" (click)="importNewJs()">Upload</button> 
      <div class="modal-error-message" *ngIf="displayError">
        {{errorMessage}}
      </div>
    </div>
  </div>
</div>